import {
  COMPANYSETTINGS,
    CONTRACTRESOURCES,
    DASHBOARD,
    POSITIONS,
    SETTINGS,
  } from "../navigation/CONSTANTS";

export const Skills = [
    { name: "React", id: 1 },
    { name: "Ruby on Rails", id: 2 },
    { name: "Python", id: 3 },
    { name: "Angular", id: 4 },
    { name: "iOS Swift", id: 5 },
    { name: "PHP", id: 6 },
    { name: "Flutter", id: 7 },
    { name: "Golang", id: 8 },
    { name: "Android(Kotlin)", id: 9 },
    { name: "DevOps+", id: 10 },
    { name: "Machine Learning/Data Science", id: 11 },
    { name: "Data Engineering", id: 12 },
    { name: "Java", id: 1452 },
    { name: "Node Js", id: 1331 },
    { name: ".Net", id: 1990 },
    { name: "Others", id: 16 }
]

export const companySize = [
    '1-50',
    '51-100',
    '101-500',
    '500+'
]

export const ImageUrl = 'https://ellow-dev-static-content.s3.ap-south-1.amazonaws.com/';

export const remoteWork = [ {label: 'Yes', value: 0 }, {label: 'No', value: 1} ];

export const duration = [ {label: 'Short Term', value: 0 }, {label: 'Medium Term', value: 1}, {label: 'Long Term', value: 2} ];

export const availabilityRadio = [ {label: 'ASAP', value: 0}, {label: 'Within 2 weeks', value: 1}, {label: 'Within a month', value: 2}, {label: 'More than a month', value: 3} ];

export const countryList = ["United States","India", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and/or Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon","Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France, Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Honduras", "Hong Kong", "Hungary", "Iceland", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia South Sandwich Islands", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States minor outlying islands", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zaire", "Zambia", "Zimbabwe"]

export const cityList = ["Bhandup", "Mumbai", "Visakhapatnam", "Coimbatore", "Delhi", "Bangalore", "Pune", "Nagpur", "Lucknow", "Vadodara", "Indore", "Jalalpur", "Bhopal", "Kolkata", "Kanpur", "New Delhi", "Faridabad", "Rajkot", "Ghaziabad", "Chennai", "Meerut", "Agra", "Jaipur", "Jabalpur", "Varanasi", "Allahabad", "Hyderabad", "Noida", "Howrah", "Thane", "Patiala", "Chakan", "Ahmedabad", "Manipala", "Mangalore", "Panvel", "Kochi"]

export let sideMenu = [
    {
      icon: "lucide:home",
      title: "Dashboard",
      url: DASHBOARD,
      active: false,
    },
    {
      icon: "ant-design:crown-outlined",
      title: "Positions",
      url: POSITIONS,
      active: false,
    },
    {
      icon: "heroicons-outline:users",
      title: "Contract Resources",
      url: CONTRACTRESOURCES,
      active: false,
    },
    {
      icon: "tabler:settings",
      title: "Settings",
      url: COMPANYSETTINGS,
      active: false,
    },
    // {
    //   icon: "lucide:book-open",
    //   title: "Reports",
    //   url: "",
    //   active: false,
    // }, <Icon icon="tabler:settings" />
    // {
    //   icon: "ci:bar-chart-alt",
    //   title: "Summary Reports",
    //   url: "",
    //   active: false,
    // },
];
  
export const customerId = '479d0f4e-a437-45d1-9bf4-c3b8610af730'
  
export const testLoginId = 'c42ff1ff-dd86-4c11-8e64-47f1b3ed9d04'

  export const typeOfJob = ["Contract", "Contract to hire", "Full time"];

  export const priority = [
    { name: "Hot", id: 3 },
    { name: "Warm", id: 2 },
    { name: "Cold", id: 1 },
  ];

  export const contractDuration = ["1 Month","2 Months","3 Months","4 Months","5 Months","6 Months","7 Months","8 Months","9 Months","10 Months","11 Months","12 Months","13 Months","14 Months","15 Months","16 Months","17 Months","18 Months","19 Months","20 Months","21 Months","22 Months","23 Months","24 Months"];

  export const billingType = ["Hourly", "Daily", "Month"];

  export const currency = ["INR", "USD"];

  export const localizedData = [
    { text: "Immediately", value: 1 },
    { text: "In a coming date", value: 2 },
    { text: "In a week defined", value: 3 },
    { text: "Unavailable for Jobs", value: 4 },
    { text: "In Contract", value:5}
  ];

  export const localizedData2 = [
    { text: "Jothis Joseph", value: 1 },
    { text: "Remya", value: 2 },
    { text: "Ejas Mujeeb", value: 3 },
    { text: "Abhijith", value: 4 },
    { text: "Varun Sankar Nair", value: 5 },
    { text: "Sruthi", value: 6 },
    { text: "Meera", value: 7 },
    { text: "Nithin", value: 8 },
    { text: "Jephin", value: 9 },
    { text: "Anju", value: 10 },
    { text: "Chippy", value: 11 },
    { text: "Rahul Raj", value: 12 },
    { text: "Tanvi Tyagi", value: 13 },
    { text: "Jasleen", value: 14 },
    { text: "Jisha", value: 15 },
  ];
  
  export const localizedData3 = [
    { text: "cold", value: 1 },
    { text: "warm", value: 2 },
    { text: "hot", value: 3 },
  ]

  export const positionStatuswithId = [ { name: 'Shortlist', id: 2 }, { name: 'Reject', id: 3 }]

  export const timeSheetstatus = [{ name: "Approved", id: 3 }, { name: "Rejected", id: 4 }, { name: "Pending", id: 2 } ]